import "core-js";
import {
  existsElement,
  existsChildElement,
  setTextToElement,
  setContentToElement,
  formattedPrice,
  setAttribute,
  removeAttribute,
  getTextContent,
  addEvent,
  removeEvent,
  findParentElement,
  getInputValue,
  setInputValue,
  addElementClass,
  removeElementClass,
  setStyle,
} from "@/libs/cart/utility";
import {
  updateElement,
  updateElementText,
  updateElementFormattedText,
  addElementAttribute,
  updateOrderUnConfirmed,
  updateShippingFee,
  updateShippingFeeSupport,
  updateFreezingFeeSupport,
  toggleElementsByType,
  updateOrderIsConfirmed,
} from "@/libs/cart/subtotal";
import {
  makeOptions,
  cartItemTemplate,
  cartItemAtDetailTemplate,
  getTemplateCartItems,
  getTemplateCartItemsAtDetail,
  updateCartItems,
} from "@/libs/cart/item";
import {
  invokeChangeCartOrderItemQuantities,
  invokeDeleteCartOrderItem,
  invokeBulkDeleteCartOrderItem,
  invokeRestoreCartOrderItem,
  invokeBulkRestoreCartOrderItem,
  updateCartOrderItems,
  showErrorDialog,
} from "@/libs/cart/order";
import {
  mountedQuantitySelect,
  mountedDeleteElement,
  mountedBulkDeleteElement,
  mountedRestoreElement,
  mountedBulkRestoreElement,
} from "@/libs/cart/order/events";
import {
  findChangedCartOrderItem,
  filterCartOrderItem,
  toggleItemActionElements,
  omit,
} from "@/libs/cart/order/utility";
import {
  mountedCartOrderDeliverySelect,
  invokeChangeCartOrderDelivery,
  closeDialog,
  nextStep,
  invokeDialogStepper,
  showDialog,
  template,
  createDialogMessage,
  hideAllDialogs,
  isAcceptedDialogByMenuKey,
  mountedCartOrderDeliveryButton,
  invokeChangeCartOrderDeliveryConfirmDialog,
} from "@/libs/cart/dialog";
import { get, save } from "@/libs/api/dialog";
import {
  mountedModalElement,
  invokeOpenModal,
  invokeCloseModal,
} from "@/libs/cart/modal";
import {
  showInitialCartView,
  setStyleByScrollArea,
  updateEmptyStateOfCartItems,
  aggregateElementsHeight,
} from "@/libs/cart";
import {
  updateAvaiablePoint,
  mountedOrderCofirmButtonElement,
  invokeSubmitOrderCofirmForm,
  updateOrderCofirmButtonElement,
  mountedInputPoint,
  invokeCheckedInput,
} from "@/libs/cart/detail";
declare global {
  interface Window {
    cart: any;
  }
}

const _createDialogMessage = createDialogMessage(
  "<strong>変更は完了していません</strong>変更を完了させるには、「注文確定に進む」を押し、注文を確定させてください。",
  "・[$name$]<br/>",
  "上記商品は、ご予約いただいている商品です。<br/>削除してよろしいでしょうか？"
);

const _nextStep = nextStep(
  addEvent,
  removeEvent,
  ".js-dialog-next",
  ".js-dialog-cancel",
  "#js-alert-overlay"
);

const _showDialog = showDialog(
  "body",
  "data-scroll-event-disabled",
  template,
  _nextStep
);

const _isAcceptedDialogByMenuKey = isAcceptedDialogByMenuKey(get);

const _invokeDialogStepper = invokeDialogStepper(
  _showDialog,
  _createDialogMessage,
  _isAcceptedDialogByMenuKey,
  save,
  getInputValue,
  "#js-beginner-user"
);

const _toggleItemActionElements = toggleItemActionElements(
  setAttribute,
  removeAttribute,
  ".js-order-item-quantity",
  ".js-order-item-empty",
  ".js-order-item-restore",
  ".js-order-item-delete"
);

const _showErrorDialog = showErrorDialog(
  _showDialog,
  setAttribute,
  removeAttribute,
  ".js-order-item",
  ".js-order-item-quantity",
  ".js-order-item-restore",
  ".js-order-item-delete"
);

const _hideAllDialogs = hideAllDialogs(
  removeAttribute,
  "#js-cart-order-items",
  ".js-order-item-quantity",
  ".js-order-item-restore",
  ".js-order-item-delete"
);

window.cart = {};

/**
 * カート初回アクセス表示
 */
window.cart.showInitialCartView = showInitialCartView(
  existsElement,
  getInputValue,
  setAttribute,
  'input[name="isCartDisp"]',
  "#zoom-cart-trigger"
);

/**
 * カート内スクロールエリアの高さ指定
 */
window.cart.setStyleByScrollArea = setStyleByScrollArea(
  existsElement,
  aggregateElementsHeight,
  setStyle,
  "#js-cart-scroll-area"
);

/**
 * カート内スクロールエリアの高さをリセットする
 */
window.cart.resetStyleByScrollArea = () =>
  setStyle("#js-cart-scroll-area", {
    maxHeight: "",
  });

/**
 * カート商品0件（エンプティステート）
 */
window.cart.updateEmptyStateOfCartItems = updateEmptyStateOfCartItems(
  existsElement,
  getInputValue,
  setAttribute,
  removeAttribute,
  "#js-cart-empty",
  "#js-cart-order-items-count"
);

/**
 * カート情報
 */
window.cart.subtotal = {};

/**
 * カート情報 > カート小計
 */
window.cart.subtotal.updateCartSubtotal = updateElementFormattedText(
  existsElement,
  setTextToElement,
  formattedPrice,
  "#js-cart-subtotal-num"
);

/**
 * カート情報 > 代引き手数料
 */
window.cart.subtotal.updateCashOnDelivery = updateElement(
  existsElement,
  existsChildElement,
  setTextToElement,
  formattedPrice,
  setAttribute,
  removeAttribute,
  "#js-cash-on-delivery",
  "#js-cash-on-delivery-num"
);

/**
 * カート情報 > 送料
 */
window.cart.subtotal.updateShippingFee = updateElementFormattedText(
  existsElement,
  setTextToElement,
  formattedPrice,
  "#js-shipping-fee"
);

/**
 * カート情報 > 定期配送値引
 */
window.cart.subtotal.updateRegularDeliveryDiscount = updateElement(
  existsElement,
  existsChildElement,
  setTextToElement,
  formattedPrice,
  setAttribute,
  removeAttribute,
  "#js-regular-delivery-discount",
  "#js-regular-delivery-discount-num"
);

/**
 * カート情報 > 冷凍手数料
 */
window.cart.subtotal.updatefreezingFee = updateElement(
  existsElement,
  existsChildElement,
  setTextToElement,
  formattedPrice,
  setAttribute,
  removeAttribute,
  "#js-freezing-fee",
  "#js-freezing-fee-num"
);

/**
 * カート情報 > ポイント割引
 */
window.cart.subtotal.updatePointDiscount = updateElement(
  existsElement,
  existsChildElement,
  setTextToElement,
  formattedPrice,
  setAttribute,
  removeAttribute,
  "#js-point-discount",
  "#js-point-discount-num"
);

/**
 * カート情報 > 合計
 */
window.cart.subtotal.updateTotalPayment = updateElementFormattedText(
  existsElement,
  setTextToElement,
  formattedPrice,
  "#js-total-payment-num"
);

/**
 * カート情報 > 送料サポート
 */
window.cart.subtotal.updateShippingFeeSupport = updateShippingFeeSupport(
  existsElement,
  setTextToElement,
  formattedPrice,
  setAttribute,
  removeAttribute,
  getTextContent,
  "#js-shipping-fee-support",
  "#js-discount-needs-num",
  "#js-discount-price",
  "#js-discount-est-num",
  "#js-replication-shipping-fee-support"
);

/**
 * カート情報 > 冷凍手数料サポート
 */
window.cart.subtotal.updateFreezingFeeSupport = updateFreezingFeeSupport(
  existsElement,
  setTextToElement,
  formattedPrice,
  setAttribute,
  removeAttribute,
  getTextContent,
  "#js-freezing-fee-support",
  "#js-freezing-fee-support-freeze",
  "#js-freezing-fee-support-total",
  "#js-replication-freezing-fee-support"
);

/**
 * カート情報 > お届け期間
 */
window.cart.subtotal.updateDeliveryPeriod = updateElementText(
  existsElement,
  setTextToElement,
  "#js-delivery-period"
);

/**
 * カート情報 > 注文締切日
 */
window.cart.subtotal.updateOrderDeadline = updateElementText(
  existsElement,
  setTextToElement,
  "#js-order-deadline"
);

/**
 * カート情報 > お届け日
 */
window.cart.subtotal.updateOrderDelivery = updateElementText(
  existsElement,
  setTextToElement,
  "#js-cart-order-delivery"
);

/**
 * カート情報 > 注文未確定商品の小計表示切り替え
 */
window.cart.subtotal.updateOrderUnConfirmedSubtotal = updateOrderUnConfirmed(
  existsElement,
  setAttribute,
  removeAttribute,
  "#js-order-unconfirmed"
);

/**
 * カート情報 > 追加商品
 */
window.cart.subtotal.updateAdditionalItems = updateElement(
  existsElement,
  existsChildElement,
  setTextToElement,
  formattedPrice,
  setAttribute,
  removeAttribute,
  "#js-additional-items",
  "#js-additional-items-num"
);

/**
 * カート情報 > 削除商品
 */
window.cart.subtotal.updateDeletedItems = updateElement(
  existsElement,
  existsChildElement,
  setTextToElement,
  formattedPrice,
  setAttribute,
  removeAttribute,
  "#js-deleted-items",
  "#js-deleted-items-num"
);

/**
 * カート情報 > お届け予定商品
 */
window.cart.subtotal.updateOrderedItems = updateElementFormattedText(
  existsElement,
  setTextToElement,
  formattedPrice,
  "#js-ordered-items-num"
);

/**
 * カート情報 > カート数量
 */
window.cart.subtotal.updateTotalCount = updateElementFormattedText(
  existsElement,
  setTextToElement,
  formattedPrice,
  "#js-total-quantity-num"
);

/**
 * カート情報 > ご注文に進むフォームのアクション先のセット
 */
window.cart.subtotal.setToOrderAction = addElementAttribute(
  existsElement,
  setAttribute,
  "#js-to-order"
);

/**
 * カート情報 > カート小計内訳エリア表示切り替え
 */
window.cart.subtotal.toggleCartSubtotalBreakdown = toggleElementsByType(
  existsElement,
  setAttribute,
  removeAttribute,
  "#js-cart-subtotal-breakdown",
  "#js-cart-detail-breakdown"
);

/**
 * カート情報 > 注文未確定かどうか
 */
window.cart.subtotal.updateOrderIsConfirmed = updateOrderIsConfirmed(
  existsElement,
  setInputValue,
  "#js-order-is-confirmed"
);

/**
 * カート情報 > 一括処理アクション表示切り替え
 */
window.cart.subtotal.toggleCartOrderBulkAction = toggleElementsByType(
  existsElement,
  setAttribute,
  removeAttribute,
  "#js-order-item-bulk-restore",
  "#js-order-item-bulk-delete"
);

/**
 * カート情報 > カタログ号数
 */
window.cart.subtotal.updateCatalogNumber = updateElementText(
  existsElement,
  setTextToElement,
  "#js-catalog-number"
);

/**
 * ヘッダーカート情報
 */
window.cart.subtotal.header = {};

/**
 * ヘッダーカート情報 > 冷凍手数料
 */
window.cart.subtotal.header.updatefreezingFee = updateElement(
  existsElement,
  existsChildElement,
  setTextToElement,
  formattedPrice,
  setAttribute,
  removeAttribute,
  "#js-header-freezing-fee",
  "#js-header-freezing-fee-num"
);

/**
 * ヘッダーカート情報 > カート小計
 */
window.cart.subtotal.header.updateCartSubtotal = updateElementFormattedText(
  existsElement,
  setTextToElement,
  formattedPrice,
  "#js-header-cart-subtotal-num"
);

/**
 * ヘッダーカート情報 > 合計
 */
window.cart.subtotal.header.updateTotalPayment = updateElementFormattedText(
  existsElement,
  setTextToElement,
  formattedPrice,
  "#js-header-total-payment-num"
);

/**
 * ヘッダーカート情報 > カート数量
 */
window.cart.subtotal.header.updateTotalCount = updateElement(
  existsElement,
  existsChildElement,
  setTextToElement,
  formattedPrice,
  setAttribute,
  removeAttribute,
  "#js-header-total-quantity",
  "#js-header-total-quantity-num"
);

/**
 * ヘッダーカート情報 > 未確定商品
 */
window.cart.subtotal.header.updateOrderUnConfirmed = updateOrderUnConfirmed(
  existsElement,
  setAttribute,
  removeAttribute,
  "#js-header-order-unconfirmed"
);

/**
 * ヘッダーカート情報 > 数量変更時の未確定商品
 */
window.cart.subtotal.header.updateTotalUnConfirmed = updateOrderUnConfirmed(
  existsElement,
  setAttribute,
  removeAttribute,
  "#js-header-total-unconfirmed"
);

/**
 * ヘッダーカート情報 > 送料
 */
window.cart.subtotal.header.updateShippingFee = updateShippingFee(
  existsElement,
  setTextToElement,
  setAttribute,
  removeAttribute,
  "#js-header-shipping-fee"
);

/**
 * カート商品情報
 */
window.cart.item = {};

/**
 * カート商品 > テンプレート取得
 */
window.cart.item.getTemplateCartItems = getTemplateCartItems(
  cartItemTemplate,
  formattedPrice,
  makeOptions,
  "js-cart-item-select",
  "js-cart-item-delete"
);

/**
 * カート商品 > 注文確認画面用テンプレート取得
 */
window.cart.item.getTemplateCartItemsAtDetail = getTemplateCartItemsAtDetail(
  cartItemAtDetailTemplate,
  formattedPrice,
  makeOptions,
  "js-cart-item-select",
  "js-cart-item-delete"
);

/**
 * カート商品 > 注文未確定商品数
 */
window.cart.item.updateOrderUnConfirmedQuantity = updateElement(
  existsElement,
  existsChildElement,
  setTextToElement,
  formattedPrice,
  setAttribute,
  removeAttribute,
  "#js-order-unconfirmed-warn",
  "#js-order-unconfirmed-quantity-num"
);

/**
 * カート商品 > カート商品DOM更新
 */
window.cart.item.updateCartItems = updateCartItems(
  formattedPrice,
  "data-itemCode",
  ".cart-body-item__name",
  ".js-cart-item-point",
  ".cart-additional__point",
  ".cart-body-item__img img",
  'p[class^="s-cold-storage--"]',
  "s-cold-storage--",
  ".cart-body-item__calculate p",
  ".js-cart-item-select",
  ".js-cart-item-delete"
);

/**
 * お届け予定商品情報
 */
window.cart.order = {};

/**
 * カート商品 > 数量変更
 */
window.cart.order.mountedQuantitySelect = mountedQuantitySelect(
  existsElement,
  addEvent,
  invokeChangeCartOrderItemQuantities(
    findParentElement,
    getInputValue,
    setContentToElement,
    makeOptions,
    setAttribute,
    removeAttribute,
    updateCartOrderItems,
    _showErrorDialog,
    findChangedCartOrderItem,
    _invokeDialogStepper,
    ".js-order-item",
    "#js-order-number",
    ".js-order-item-delete"
  ),
  ".js-order-item-quantity"
);

/**
 * カート商品 > 削除ボタン
 */
window.cart.order.mountedDeleteElement = mountedDeleteElement(
  existsElement,
  addEvent,
  invokeDeleteCartOrderItem(
    findParentElement,
    getInputValue,
    setAttribute,
    removeAttribute,
    updateCartOrderItems,
    _showErrorDialog,
    findChangedCartOrderItem,
    _toggleItemActionElements,
    _invokeDialogStepper,
    ".js-order-item",
    "#js-order-number",
    ".js-order-item-quantity",
    "js-reserved-item",
    ".js-order-item-name"
  ),
  ".js-order-item-delete"
);

/**
 * カート商品 > 一括削除ボタン
 */
window.cart.order.mountedBulkDeleteElement = mountedBulkDeleteElement(
  existsElement,
  addEvent,
  invokeBulkDeleteCartOrderItem(
    filterCartOrderItem,
    getInputValue,
    updateCartOrderItems,
    setAttribute,
    removeAttribute,
    _showErrorDialog,
    _toggleItemActionElements,
    _invokeDialogStepper,
    _hideAllDialogs,
    omit,
    ".js-order-item",
    "#js-order-number",
    ".js-order-item-delete",
    "js-reserved-item",
    ".js-order-item-name",
    "#js-cart-order-items",
    '[data-item-status="isCanceled"], .js-undeletable-item'
  ),
  "#js-order-item-bulk-delete"
);

/**
 * カート商品 > 削除ボタン
 */
window.cart.order.mountedRestoreElement = mountedRestoreElement(
  existsElement,
  addEvent,
  invokeRestoreCartOrderItem(
    findParentElement,
    getInputValue,
    setContentToElement,
    makeOptions,
    setAttribute,
    updateCartOrderItems,
    _showErrorDialog,
    findChangedCartOrderItem,
    _toggleItemActionElements,
    ".js-order-item",
    "#js-order-number",
    ".js-order-item-quantity"
  ),
  ".js-order-item-restore"
);

/**
 * カート商品 > 一括戻すボタン
 */
window.cart.order.mountedBulkRestoreElement = mountedBulkRestoreElement(
  existsElement,
  addEvent,
  invokeBulkRestoreCartOrderItem(
    filterCartOrderItem,
    getInputValue,
    setContentToElement,
    makeOptions,
    updateCartOrderItems,
    setAttribute,
    _showErrorDialog,
    _toggleItemActionElements,
    _hideAllDialogs,
    ".js-order-item",
    "#js-order-number",
    ".js-order-item-restore",
    "#js-cart-order-items",
    '[data-item-status=""], .js-undeletable-item',
    ".js-order-item-quantity"
  ),
  "#js-order-item-bulk-restore"
);

/**
 * ダイアログ/アラートなどの情報
 */
window.cart.dialog = {};

/**
 * お届け日変更アラート
 */
window.cart.dialog.mountedCartOrderDeliverySelect = mountedCartOrderDeliverySelect(
  existsElement,
  addEvent,
  getInputValue,
  invokeChangeCartOrderDelivery(
    existsElement,
    setInputValue,
    getInputValue,
    setAttribute,
    removeAttribute,
    closeDialog(addEvent, removeEvent, "#js-dialog-close"),
    nextStep(addEvent, removeEvent, "#js-dialog-next", "", ""),
    "#js-order-is-confirmed",
    "#js-changed-delivery-dialog"
  ),
  "#js-cart-order-delivery-select"
);

/**
 * お届け日変更確認ダイアログ
 */
window.cart.dialog.mountedCartOrderDeliveryButton = mountedCartOrderDeliveryButton(
  existsElement,
  addEvent,
  invokeChangeCartOrderDeliveryConfirmDialog(
    existsElement,
    addEvent,
    removeEvent,
    setAttribute,
    removeAttribute,
    invokeSubmitOrderCofirmForm(existsElement, "#js-cart-order-delivery-form"),
    "#js-changed-delivery-confirm-dialog",
    "#js-confirm-dialog-agreement",
    "#js-confirm-dialog-cancel"
  ),
  "#js-cart-order-delivery-change"
);

/**
 * お届け日変更確認ダイアログ（リンク）
 */
window.cart.dialog.mountedCartOrderDeliveryLink = mountedCartOrderDeliveryButton(
  existsElement,
  addEvent,
  invokeChangeCartOrderDeliveryConfirmDialog(
    existsElement,
    addEvent,
    removeEvent,
    setAttribute,
    removeAttribute,
    invokeSubmitOrderCofirmForm(existsElement, "#js-cart-order-delivery-form"),
    "#js-changed-delivery-confirm-dialog",
    "#js-confirm-dialog-agreement",
    "#js-confirm-dialog-cancel"
  ),
  "#js-cart-order-delivery-change-link"
);

/**
 * 注文確認情報
 */
window.cart.detail = {};

/**
 * 注文確認 > ご利用可能ポイント
 */
window.cart.detail.updateAvaiablePoint = updateAvaiablePoint(
  existsElement,
  getInputValue,
  setTextToElement,
  formattedPrice,
  "#js-total-point",
  "#js-available-point"
);

/**
 * 注文確認 > ポイント利用入力
 */
window.cart.detail.updateInputPoint = mountedInputPoint(
  existsElement,
  addEvent,
  invokeCheckedInput(existsElement, 'input[name="pointOption"]', ["3"]),
  "#js-input-point"
);

/*
 * ヘッダーカート情報 > 注文確定フォーム送信ボタン
 */
window.cart.detail.mountedOrderCofirmButtonElement = mountedOrderCofirmButtonElement(
  existsElement,
  addEvent,
  invokeSubmitOrderCofirmForm(existsElement, "#js-order-confirm-form"),
  "#js-submit-order-confirm-form"
);

/**
 * ヘッダーカート情報 > 注文確定ボタン
 */
window.cart.detail.updateOrderCofirmButtonElement = updateOrderCofirmButtonElement(
  existsElement,
  setContentToElement,
  addElementClass,
  removeElementClass,
  "#js-submit-order-confirm-form",
  "is-confirmed"
);

/**
 * モーダル
 */
window.cart.modal = {};

/**
 * トップ > モーダル
 */
window.cart.modal.mountedModalElement = mountedModalElement(
  existsElement,
  getInputValue,
  invokeOpenModal(
    existsElement,
    existsChildElement,
    addEvent,
    invokeCloseModal(removeEvent),
    "#js-modal",
    ".js-modal-close",
    "#js-modal-overlay"
  ),
  'input[name="isFirstView"]'
);
